import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Trans } from "@lingui/react/macro"
import { Alert, Button, Paper, Stack, Text, TextInput, Title } from "@mantine/core"
import { createFileRoute } from "@tanstack/react-router"
import { useState } from "react"
import { extractErrorMessage } from "../lib/api/errors"
import { authClient } from "../lib/auth-client"

function TwoFactorPage(): React.JSX.Element {
  const [code, setCode] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const { i18n } = useLingui()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")
    setLoading(true)

    try {
      await authClient.twoFactor.verifyTotp(
        { code, trustDevice: true },
        {
          onSuccess() {
            window.location.href = "/"
          },
          onError(ctx: { error?: { message?: string } }) {
            setError(ctx.error?.message || i18n._(msg`Invalid code`))
          },
        },
      )
    } catch (err: unknown) {
      setError(extractErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-content">
        <Paper radius="md" p="xl" withBorder bg="var(--mantine-color-body)" style={{ opacity: 0.95 }}>
          <Stack align="center" mb="md">
            <Title order={2}>
              <Trans>Two-factor authentication</Trans>
            </Title>
            <Text c="dimmed" size="sm">
              <Trans>Enter the code from your authenticator app</Trans>
            </Text>
          </Stack>

          {error && (
            <Alert color="danger" mb="md" variant="light">
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Stack>
              <TextInput
                className="two-factor-input"
                aria-label={i18n._(msg`Verification code`)}
                placeholder="000000"
                value={code}
                onChange={(e) => setCode(e.currentTarget.value.replace(/\D/g, "").slice(0, 6))}
                required
                autoFocus
                autoComplete="one-time-code"
                maxLength={6}
              />
              <Button type="submit" fullWidth loading={loading} disabled={code.length !== 6}>
                <Trans>Verify</Trans>
              </Button>
            </Stack>
          </form>
        </Paper>
      </div>
    </div>
  )
}

export const Route = createFileRoute("/two-factor")({
  component: TwoFactorPage,
})
